exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1T90C{position:relative;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center;text-align:center;border-radius:4px;width:700px;display:-webkit-box;display:-ms-flexbox;display:flex;padding:25px 25px 35px}._1KLV3{padding:25px 0;width:95%}._10bvs{min-width:400px;height:auto}._1kzLV{width:90%;max-height:350px;overflow-y:auto}.c3MdG{font-weight:700;font-size:15px;padding:20px 15px 5px;text-align:left}._363Qw{padding:20px 25px 5px}._3S9mt{text-align:justify;font-size:13px}.xI3LP{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;padding-bottom:15px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3Y8Tw{font-size:16px!important}._2N4d3{position:relative}._1p_Tp{position:absolute;width:12px;height:auto;top:25px;left:-2px}._2u9wZ{top:24px;left:5px}._1fhY0{line-height:16px;font-size:13px;padding:0 25px}._1-J7S{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px}._1-J7S:before{content:\"\\D7\"}", ""]);

// exports
exports.locals = {
	"modal": "_1T90C",
	"mobileModal": "_1KLV3",
	"desktopRoot": "_10bvs",
	"mobileRoot": "_1kzLV",
	"optionTitles": "c3MdG",
	"mobileOptionTitles": "_363Qw",
	"description": "_3S9mt",
	"modalWarrantyBlock": "xI3LP",
	"tooltipTitle": "_3Y8Tw",
	"modalOptions": "_2N4d3",
	"checkboxIcon": "_1p_Tp",
	"mobileCheckboxIcon": "_2u9wZ",
	"optionDescription": "_1fhY0",
	"closeBtn": "_1-J7S"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/WarrantyModal/WarrantyModal.css
// module id = 2058
// module chunks = 18 19 32 37